import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { useGetDetailRequests } from "../hooks/get-detail-request";
import { Skeleton } from "antd";
import { DETAIL } from "../constant/field-names";
import { Row, Col } from "antd";
import { EditableTable } from "./EditableTable/Table";
import { eFields } from "../constant/field-names";

export const Information: FC = () => {
  const { data, isLoading } = useGetDetailRequests();

  if (isLoading) return <Skeleton />;

  return (
    <div>
      <Box title="Thông tin phiếu đăng ký cấp văn phòng phẩm">
        <Row gutter={[32, 0]}>
          {DETAIL.map((value) => {
            return (
              <Col span={value.span}>
                <Row gutter={[32, 0]}>
                  <Col span={12}>{value.label}</Col>
                  <Col span={12} className="font-weight-bold">
                    {data.fields?.[value.field]}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Box>

      <Box title="Thông tin chi tiết">
        <EditableTable
          eRequests={JSON.parse(data.fields.eContent)}
          setERequests={null}
          eFields={eFields}
          formFileName="PhieuDeNghiVanPhongPham"
          title=""
          mode="view"
        />
      </Box>
    </div>
  );
};
